// extracted by mini-css-extract-plugin
export default {"survey_card":"SurveysList_survey_card__xQ4ah"};